import { getAppVersion, isIos } from "@/utils/lodash";

/*
 * JavaScript实现版本号比较
 * 传入两个字符串，当前版本号：curV；比较版本号：reqV
 */
export const judgeVersion: any = (curV: any, reqV: any) => {
  if (curV && reqV) {
    const curArr: any = curV.split(".");
    const reqArr: any = reqV.split(".");

    // 将版本号拆成数字
    const minL: any = Math.min(curArr.length, reqArr.length);
    let pos: any = 0; // 当前比较的位数
    let diff: any = 0; // 当前位数是否相等

    //逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
      diff = parseInt(curArr[pos]) - parseInt(reqArr[pos]);
      if (diff !== 0) {
        break;
      }
      pos++;
    }
    return diff >= 0;
  } else {
    return false;
  }
};

export const versionGreaterThan: any = (version: string) =>
  judgeVersion(getAppVersion(), version);

/**
 * 是否支持本地视频或者文件
 */
export const isSupportLocalFiles: any = () => {
  if (versionGreaterThan("4.8.0")) {
    return true;
  } else {
    return false;
  }
};

/**
 * 视屏是否支持自动播放
 */
export const isAutoPlaySupported: any = () => {
  if (!isIos()) {
    return true;
  }
  return versionGreaterThan("4.6.0");
};
